import { API_BASE_URL } from './apiConfig';

function resolveImageSource(src) {
  if (!src || /^(https?:|data:|blob:)/.test(src)) return src;
  return `${API_BASE_URL}${src.startsWith('/') ? '' : '/'}${src}`;
}

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('No se pudo incorporar una imagen al módulo.'));
    reader.readAsDataURL(blob);
  });
}

async function portableImageSource(src) {
  if (!src || src.startsWith('data:')) return src;
  const response = await fetch(resolveImageSource(src), { cache: 'no-store' });
  if (!response.ok) throw new Error(`No se pudo descargar la imagen (${response.status}).`);
  return blobToDataUrl(await response.blob());
}

export async function buildSiteContentModule(content) {
  const portableContent = JSON.parse(JSON.stringify(content));
  const failedSlots = [];

  await Promise.all(Object.entries(portableContent.images || {}).map(async ([slot, image]) => {
    try {
      image.src = await portableImageSource(image.src);
    } catch (error) {
      failedSlots.push(slot);
    }
  }));

  if (failedSlots.length) {
    throw new Error(`No se pudieron incorporar estas fotos: ${failedSlots.join(', ')}. Vuelve a seleccionarlas y exporta nuevamente.`);
  }

  return [
    '// Snapshot generado desde /site-admin.',
    '// Guarda este archivo como src/config/siteContent.snapshot.js y vuelve a desplegar GitHub Pages.',
    `export const siteContentSnapshot = ${JSON.stringify(portableContent, null, 2)};`,
    ''
  ].join('\n');
}

export async function downloadSiteContentModule(content) {
  const source = await buildSiteContentModule(content);
  const url = URL.createObjectURL(new Blob([source], { type: 'text/javascript;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = 'siteContent.snapshot.js';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
